'use client';

import { useEffect, useState } from 'react';
import { configLightboxSize } from '@/app/lib/utils/helpers';
import FigureStatementBelow from './figure-statement-below';

interface Props {
  src: string;
  alt: string;
  lightboxPortalId: string;
  width: number;
  height: number;
}

const FigureStatementContainerBelow = ({
  src,
  alt,
  width,
  height,
  lightboxPortalId
}: Props) => {
  const { lightboxWidths, lightboxHeights } = configLightboxSize(src);

  const [lightboxPortal, setLightboxPortal] = useState<
    HTMLElement | null | undefined
  >(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setLightboxPortal(document.getElementById(lightboxPortalId));
  }, [lightboxPortalId]);

  return (
    <FigureStatementBelow
      src={src}
      alt={alt}
      width={width}
      height={height}
      lightboxWidths={lightboxWidths}
      lightboxHeights={lightboxHeights}
      open={open}
      setOpen={setOpen}
      lightboxPortal={lightboxPortal}
    />
  );
};

export default FigureStatementContainerBelow;
